<section class="error-statelayout">
    <div class="container">
        <div class="error-container">
            <div class="error-content">
                <h1 class="heading-text">Oops! {{errorCode}}</h1>
                <div class="p-description">
                    <p>Sorry, Something went wrong. You can try again or return to the homepage.</p>
                </div>
                <div class="action-rows">
                    <button mat-button class="button--primary-large" (click)="tryAgain()">Try Again</button>
                    <span>or</span>
                    <button class="link-chevron" [routerLink]="['/Dashboard']">
                        <span>Go to Homepage</span>
                        <mat-icon fontSet="material-symbols-outlined">chevron_right</mat-icon>
                    </button>
                </div>
            </div>

            @if ([400, 401, 404, 429, 501].includes(errorCode)) {
                <div class="error-illustration">
                    <img src="assets/images/Illustrations-oops.svg" alt="Opps">
                </div>
            }
        </div>
    </div>
</section>